<template>
    <global-layout>
        <el-breadcrumb separator="/" v-show="show" style="padding: 18px 20px 14px">
            <el-breadcrumb-item
                v-for="item in $route.matched"
                v-if="item.meta.title"
                :to="{ path: item.path ? item.path : '/' }">
                {{ item.meta.title }}
            </el-breadcrumb-item>
        </el-breadcrumb>
        <div style="padding: 0 20px 20px">
            <router-view/>
        </div>
    </global-layout>
</template>
<script>
import GlobalLayout from '../page/GlobalLayout'
export default {
    name: 'BasicLayout',
    components: {
        GlobalLayout
    },
    data () {
        return {
            show: false
        }
    },
    watch: {
        '$route.path': {
            handler(value) {
                this.show = !value.match('/home')
            },
            immediate: true
        }
    }
}
</script>
